import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getRegion } from '../../../../utils/Region';
import { findJornada, getAllJornadas } from './utils/calendarUtils';
import {
  getMundialStructure,
  getScheduleResults,
} from '../../redux/actions/calendar.actions';
import { usePrivateRoute } from '../../hooks/usePrivateRoute';
import { showMessage } from 'containers/Player/actions/alert/alerts';
import { translate } from 'containers/MundialViews/utils/mundialUtils';
//------------------------------------------------------------------------
import { RoundFilter } from './components/RoundFilter';
import { CalendarTable } from './components/CalendarTable';
import Alert from 'containers/Player/components/Alert';
import './style.scss';

export const CalendarView = () => {
  usePrivateRoute()
  // const [matches, setMatches] = useState([]);
  const [jornadaFilter, setJornadaFilter] = useState({
    jornada: null,
    notFoundResults: false,
    nextDate: '',
  });
  const [selectFilter, setSelectFilter] = useState({
    textContent: 'Todos',
    id: 'all',
    prevFilter: { textContent: 'Todos', id: 'all' },
  });
  const {
    structure,
    scheduleResults: { matches },
  } = useSelector(state => state.Mundial.Calendar);
  const translations = useSelector(
    state => JSON.parse(state.metadata.translations).language[getRegion()],
  );
  const dispatch = useDispatch();

  const { jornada, notFoundResults, nextDate } = jornadaFilter;

  //Obtiene los datos del calendario
  useEffect(() => {
    if (structure.length === 0) dispatch(getMundialStructure());
    if (matches.length === 0) dispatch(getScheduleResults());
  }, []);

  useEffect(() => {
    const tickSchedule = setInterval(() => {
      dispatch(getScheduleResults());
    }, 600000);

    return () => clearInterval(tickSchedule);
  }, []);

  //Obtiene los datos de la jornada
  useEffect(
    () => {
      if (structure.length === 0) return;
      setJornadaFilter(
        findJornada(structure, selectFilter.id, setSelectFilter),
      );
    },
    [selectFilter.id, structure, notFoundResults],
  );

  useEffect(
    () => {
      if (notFoundResults) {
        dispatch(
          showMessage(
            <>
              <span style={{ minWidth: '0.3rem' }} />
              {`${translate(
                'match_alert_title_NotMatch_label',
                translations,
              )} ${translate(
                'ribbons_soccer_result_separator_label',
                translations,
              )} ${translate(
                'match_alert_description_notMatchDefault_label',
                translations,
              )}`}
            </>,
          ),
        );
      }
    },
    [notFoundResults],
  );

  if (structure.length === 0 || matches.length === 0) return null;

  return (
    <div className="calendar-view">
      <RoundFilter
        translations={translations}
        selected={selectFilter}
        changeFilter={setSelectFilter}
      />
      {!notFoundResults &&
        jornada?.map(jor =>
          jor?.matchScheduledStartSegments?.map((dates, i) => (
            <CalendarTable
              key={`${selectFilter.id}${i}`}
              matchDates={dates}
              jornada={jor}
              jornadaId={selectFilter.id}
              matches={matches}
              translations={translations}
            />
          )),
        )}
      <Alert />
    </div>
  );
};
